import MeetingTableRow from "./MeetingTableRow";

export default MeetingTableRow;
